export default {
    message_template_create_success_message: "The message template has been created",
    message_template_create_title: "Create Message Template",
    message_template_edit_success_message: "The message template has been edited",
    message_template_edit_title: "Edit Message Template",
    message_template_name: "Name",
    message_template_status: "Status",
    message_template_active: "Active",
    message_template_inactive: "Inactive",

    message_template_code_forgot_password: "Forgot Password",
    message_template_code_verify_email: "Verify Email",
    message_template_code_verify_email_legacy: "Verify Email Legacy",
    message_template_language: "Language",
    message_template_template: "Template",
    message_template_email_from: "Email From",
    message_template_email_subject: "Email Subject",
    message_template_email_body: "Email Body",
    message_template_create_error_message: "Error creating message template",
    message_template_create_duplicate_code: "Message template code/language already exists",
    message_template_create_missing_template_fields: "All templete fields need to be added to the email body",

}